import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import SetupGuideChannelsEmailController from 'cio/pods/setup-guide/channels/email/controller';
import SetupGuide from 'cio/models/setup-guide';
import Transition from '@ember/routing/-private/transition';
import { MessagingChannelType } from 'cio/utils/setup-guide/messaging-channels';
import FeaturesService from 'ember-feature-flags/services/features';

export default class SetupGuideChannelsEmail extends Route {
  @service features!: FeaturesService;

  crumb() {
    return {
      name: 'Email',
      path: 'setup-guide.channels.email',
    };
  }

  setupController(controller: SetupGuideChannelsEmailController, model: SetupGuide, transition: Transition) {
    super.setupController(controller, model, transition);
    controller.fetchData();
  }

  redirect(model: SetupGuide) {
    if (model.messagingChannelTypes.includes(MessagingChannelType.Email)) {
      return;
    }

    if (this.features.isEnabled('test_delivery_mode')) {
      model.addChannel(MessagingChannelType.Email);
      return;
    }

    this.router.transitionTo('setup-guide.channels');
  }
}
